import request from '@/utils/request'

// 获取房间类型管理列表
export const getRoomTypeLists = (data) => {
    return request({
        url: '/room/type/lists',
        params: data
    })
}

// 获取房间类型管理选项列表
export const getRoomTypeOptionLists = (data) => {
    return request({
        url: '/room/type/option/lists',
        params: data
    })
}

// 房间类型-详情
export const getRoomTypeDetail = (id) => {
    return request({
        url: `/room/type/${id}`
    })
}

// 房间类型-添加
export const addRoomTypeApi = (data) => {
    return request({
        url: '/room/type/manage',
        method: 'POST',
        data
    })
}

// 房间类型-修改
export const putRoomTypeApi = (data) => {
    return request({
        url: '/room/type/manage',
        method: 'PUT',
        data
    })
}

// 房间类型-删除
export const delRoomType = (id) => {
    return request({
        url: `/room/type/${id}`,
        method: 'DELETE'
    })
}

/**
 * 批量处理
 * batch_update_order 更新排序
 * batch_enable 批量启用
 * batch_disable 批量禁用
 * batch_display 批量显示
 * batch_hidden 批量隐藏
 */
export const batchPatchRoomType = (method, data) => {
    return request({
        url: '/room/type/manage',
        method: 'PATCH',
        data: {
            method,
            data
        }
    })
}
